(function () {
  'use strict';

  /* ── "What makes our kits different" - staggered comic-panel pop-in ──
     Panels render fully visible by default; we only enable the hidden
     pre-state (.kd-anim) once JS is alive, so a broken script can never
     blank the section. Skipped entirely under prefers-reduced-motion. */
  function initStrip() {
    var strip = document.querySelector('.kd-strip');
    if (!strip) return;

    var reduced = window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduced || !('IntersectionObserver' in window)) return;

    var section = strip.closest('.kd-section') || strip;
    section.classList.add('kd-anim');

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          strip.classList.add('is-in');
          observer.disconnect();
        }
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.15 });
    observer.observe(strip);

    /* failsafe: never leave the panels hidden */
    setTimeout(function () { strip.classList.add('is-in'); }, 3000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStrip);
  } else {
    initStrip();
  }
})();
